var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slogan"},[_vm._l((_vm.sloganTxts),function(item,index){return _c('span',[_vm._v(_vm._s(item))])}),_c('div',{staticClass:"tabBack flex-center border",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"iconfont fanhui"}),_vm._v("返回 ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }